module.exports = __webpack_public_path__ + "img/x128.07b66e75.png";